<app-navbar></app-navbar>
<section class="remove-padding relative view-height-100vh white-bg" id="home">
    <div class="parallax-overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12 display-table view-height-100vh">
                <div class="v-align-middle text-center">
                    <div class="white-color text-center">
                        <h1 class="font-100 raleway-font font-80px line-height-80 xs-font-20px xs-line-height-20">Expand Your Reach</h1>
                        <h4 class="font-700 font-40px line-height-40">Smart Distribution & Marketing</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <video autoplay [muted]="isMuted" loop class="html5-video">
        <source src="assets/videos/explore.mp4" type="video/mp4">
        <source src="assets/videos/explore.webm" type="video/webm">
    </video>
</section>

<section class="white-bg lg-section xs-pb-100 xs-pt-100" id="features">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-right">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/concert.jpg);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6">
            <div class="section-title mb-50">
                <h2 class="raleway-font secondary-color mt-0 font-20px">What We Do</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">We Are Digital</h1>
            </div>
            <p>
                More Views empowers artists and brands with seamless <strong>distribution and marketing solutions.</strong> We ensure your content reaches the right 
                audience through <strong>cutting-edge technology, data-driven insights, and global distribution networks.</strong>
                <br>
                From digital distribution to strategic marketing campaigns, we help you maximize visibility, engagement, and revenue. Whether you're 
                launching a new product, music, or media, our expertise ensures <strong>efficient reach and impact</strong> across multiple platforms.
                <br>
                <strong>Join us and take your brand further.</strong>
            </p>
        </div>
    </div>
</section>

<section class="white-bg lg-section xs-pt-100 xs-pb-100">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/ser-dj.jpg);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6 offset-md-7 offset-md-6">
            <div class="section-title mb-50">
                <h2 class="raleway-font secondary-color mt-0 font-20px">About Us</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">We Are Partners</h1>
            </div>
            <p>
                At More Views, we specialize in <strong>distribution and marketing solutions</strong> designed to amplify your reach. 
                Our mission is to empower creators, brands, and businesses with <strong>seamless distribution, data-driven strategies, 
                and innovative marketing campaigns</strong>.  
            </p>
            <p>
                With a commitment to <strong>growth, visibility, and impact</strong>, we ensure your content reaches the right audience 
                across multiple platforms. Partner with us and take your brand to the next level.
            </p>
        </div>
    </div>
</section>

<section class="gradient-bg-two pt-80 pb-80">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title mb-50 white-color text-center">
                    <h1 class="raleway-font remove-margin font-50px font-300">Our Process</h1>
                </div>
            </div>
        </div>
        <div class="row our-process-style-02">
            <div *ngFor="let step of steps" class="col-md-3 col-sm-6 col-xs-12 line xs-mb-30 sm-mb-30">
                <div class="icon-wrap white-bg">
                    <div class="icon">
                        <i [ngClass]="step.icon"></i>
                    </div>
                </div>
                <div class="text-center white-color">
                    <h4 class="font-500">{{step.title}}</h4>
                    <p class="mb-0">{{step.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="white-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-23 text-left sm-mt-0 d-flex align-items-center">
                <div class="d-block pl-30 sm-pl-0">
                    <div class="section-title mb-50">
                        <h2 class="raleway-font secondary-color mt-0">We Are MoreViews</h2>
                        <h1 class="raleway-font mt-30 font-50px font-300">We Want You To Join Our Awesome <span class="type-it secondary-color">{{ displayedText }}</span></h1>
                    </div>
                    <p style="color: #555; max-width: 800px; margin: auto; font-size: 18px; line-height: 1.6;">
                        At <strong>MoreViews</strong>, we empower artists, labels, and music businesses with cutting-edge solutions for 
                        <strong>distribution, royalty accounting, and global payments</strong>. Our platform ensures seamless music delivery to 
                        <strong>top DSPs</strong>, transparent and automated royalty calculations, and secure multi-currency payouts worldwide.
                    </p> <br>
                    <p style="color: #555; max-width: 800px; margin: auto; font-size: 18px; line-height: 1.6;">
                        With a commitment to <strong>efficiency, accuracy, and innovation</strong>, we help music professionals 
                        <strong>maximize revenue, streamline operations, and gain deep insights</strong> into their catalog’s performance. 
                        Whether you’re an independent artist or a major label, our tools are designed to 
                        <strong>amplify your success in the ever-evolving music industry</strong>.
                    </p> <br>
                    <p style="color: #555; max-width: 800px; margin: auto; font-size: 18px; line-height: 1.6;">
                        Join us in revolutionizing music distribution and royalties—<strong>because your music deserves to be heard and paid for, effortlessly</strong>.
                    </p>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="responsive-screen mt-0">
                    <img src="assets/images/laptop.png" class="img-responsive" alt="laptop">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="gray-bg" id="about">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font secondary-color">We Are MoreViews</h2>
                    <h1 class="raleway-font">About Company</h1>
                </div>
                <p>We are a team dedicated to innovation, delivering top-quality solutions that empower businesses worldwide. Our expertise spans technology, design, and strategy to help brands grow and thrive. Committed to excellence, we turn ideas into impactful results.</p>
            </div>
        </div>
    </div>
</section>

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/sU3FkzUKHXU?si=vhtmR7XG-9HXU6Ij" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='icofont icofont-close'></i>
        </button>
    </div>
</div>

  <section class="grey-bg" id="portfolio">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font secondary-color">Scale Your 
                        Music Business</h2>
                    <h1 class="raleway-font">Our Awesome Portfolio</h1>
                </div>
                <p>Empower your distribution with cutting-edge tools. Our platform scales effortlessly from one label to thousands, providing a seamless, integrated solution for your needs.</p>
            </div>
        </div>
    </div>
</section>

<section class="parallax-bg fixed-bg" style="background-image: url('assets/images/background/bg1.jpg')">
    <div class="gradient-overlay-bg"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center parallax-content height-400px">
                <div class="center-layout">
                    <div class="v-align-middle">
                        <h1 class="font-400 white-color raleway-font xs-font-40px">We empower music, turning effort into success.</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="white-bg transition-none" id="contact">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font secondary-color">Just Keep In Touch</h2>
                    <h1 class="raleway-font">Contact Us Now</h1>
                </div>
                <p>Have questions about music distribution, royalty accounting, or payments? We’re here to help. Reach out to our team for expert support and tailored solutions. Let’s simplify your music business together!</p>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-70">
            <div class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font secondary-color">Postal Address</h2>
                            <p class="mt-30">201 se 2nd ave 
                                Miami Florida , United States
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font secondary-color">Office Numbers</h2>
                            <p class="mb-0">Mobile : +1 3058333010</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font secondary-color">Our Email</h2>
                            <p class="mb-0 mt-30">Order : info&#64;moreviews.com</p>
                            <p class="mb-0">Request : info&#64;moreviews.com</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font secondary-color">Fast Support</h2>
                            <p class="mb-0 mt-30">Support : info&#64;moreviews.com</p>
                            <p class="mb-0">Career : info&#64;moreviews.com</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-12 social-icons-style-06">
                        <ul class="md-icon left-icon">
                          <li *ngFor="let social of socialMedia">
                            <a [ngClass]="social.iconClass" href="javascript:void(0)"><i [ngClass]="social.icon"></i></a>
                          </li>
                        </ul>
                      </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <form (submit)="sendEmail($event)" class="contact-form-style-01" #contactForm="ngForm">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="user_name">Name</label>
                                <input type="text" minlength="2" maxlength="15"
                                    [class.is-invalid]="userName.invalid && userName.touched" name="user_name"
                                    class="md-input" id="name" placeholder="Name *" [(ngModel)]="formData.user_name"
                                    #userName="ngModel" required>
                                <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mb-10">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="mb-3">
                                <label class="visually-hidden" for="user_email">Email</label>
                                <input type="email" minlength="2" maxlength="35"
                                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                                    class="md-input" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                    #userEmail="ngModel" required email>
                                <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mb-10">
                                    A valid email is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="mb-3">
                                <label class="visually-hidden" for="message">Project Details</label>
                                <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                                    class="md-textarea" id="message" rows="7" placeholder="Project Details"
                                    [(ngModel)]="formData.message" #userMessage="ngModel" required></textarea>
                                <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                    Project details are required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="text-left mt-20">
                                <button type="submit" name="submit"
                                    class="btn btn-outline btn-md btn-circle btn-animate remove-margin"
                                    [disabled]="contactForm.invalid" value="Send">
                                    <span>Send Message <i class="ion-android-arrow-forward"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</section>